import React, { useState, useRef, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X, Volume2, VolumeX } from 'lucide-react';
import video from '../pages/images1/Renvitek_video.mp4';

const VIDEO_URL = video;

export const VideoIntro = ({ onComplete }) => {
  const [isPlaying, setIsPlaying] = useState(true);
  const [isMuted, setIsMuted] = useState(true);
  const videoRef = useRef(null);

  useEffect(() => {
    const video = videoRef.current;
    if (video) {
      video.play().catch(console.error);
    }
  }, []);

  const handleVideoEnd = () => {
    // wait 2 seconds then redirect
    setTimeout(() => {
      onComplete();
    }, 2000);
  };

  const handleSkip = () => {
    // wait 2 seconds then redirect
    setTimeout(() => {
      onComplete();
    }, 2000);
  };

  const toggleMute = () => {
    if (videoRef.current) {
      videoRef.current.muted = !isMuted;
      setIsMuted(!isMuted);
    }
  };

  return (
    <AnimatePresence>
      {isPlaying && (
        <motion.div
          className="video-intro"
          initial={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.8 }}
        >
          <video
            ref={videoRef}
            src={VIDEO_URL}
            muted={isMuted}
            playsInline
            onEnded={handleVideoEnd}
            className="w-full h-full object-cover"
            data-testid="intro-video"
          />

          {/* Controls */}
          <div className="absolute bottom-8 left-0 right-0 flex justify-center gap-4 z-10">
            <button
              onClick={toggleMute}
              className="glass px-6 py-3 rounded-full text-white flex items-center gap-2 hover:bg-white/20 transition-all"
              data-testid="mute-toggle-btn"
            >
              {isMuted ? <VolumeX size={20} /> : <Volume2 size={20} />}
              <span className="text-sm uppercase tracking-wider">
                {isMuted ? 'Unmute' : 'Mute'}
              </span>
            </button>

            <button
              onClick={handleSkip}
              className="bg-amber-500 hover:bg-amber-400 px-8 py-3 rounded-full text-emerald-950 font-semibold flex items-center gap-2 transition-all uppercase tracking-wider"
              data-testid="skip-intro-btn"
            >
              <X size={20} />
              Skip
            </button>
          </div>

          {/* Progress Bar */}
          <div className="absolute bottom-0 left-0 right-0 h-1 bg-white/20">
            <motion.div
              className="h-full bg-amber-500"
              initial={{ width: '0%' }}
              animate={{ width: '100%' }}
              transition={{ duration: 30, ease: 'linear' }}
            />
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default VideoIntro;